module.exports = __webpack_public_path__ + "static/media/library.ffef5dfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/library.jpg
// module id = 238
// module chunks = 0